<div class="login-component">
@if (authService.isAuthenticated()) {
    <span>{{ authService.getUserDisplayName() }} </span>
    <button mat-flat-button (click)="signOut()">Sign out</button>
} @else {
    @if (isLoggingInProgress) {
        <mat-spinner diameter="30"></mat-spinner>
    }
    <button mat-flat-button (click)="signInWithGoogle()" [disabled]="isLoggingInProgress">
        Sign in with Google
    </button>
}
</div>
